module.exports = __webpack_public_path__ + "static/presse2-d6080dba3778afcfe193cee2a2df2327.jpg";